import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const AbsenGuru = ({ token }) => {
  const [jadwalGuru, setJadwalGuru] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Deteksi Hari Ini
  const hariIndo = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  const today = hariIndo[new Date().getDay()];
  const [selectedHari, setSelectedHari] = useState(today === 'Minggu' ? 'Senin' : today);

  useEffect(() => {
    fetchJadwalGuru();
  }, [selectedHari]);

  const fetchJadwalGuru = async () => {
    setLoading(true);
    try {
      // PERBAIKAN: Menggunakan relative path agar lolos blokir CORS Nginx
      const res = await axios.get(`/api/guru-jadwal-aktif?hari=${selectedHari}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setJadwalGuru(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  // Fungsi Absen Satu-Satu
  const handleAbsen = async (guru, status) => {
    // Jika Izin/Sakit/Telat, minta keterangan
    let keterangan = '-';
    if (status !== 'hadir') {
        const { value: text } = await Swal.fire({
            title: `Keterangan ${status.toUpperCase()}`,
            input: 'text',
            inputPlaceholder: 'Tulis alasan...',
            showCancelButton: true
        });
        if (!text && status !== 'hadir') return; // Batal jika kosong (kecuali hadir)
        keterangan = text;
    }

    try {
        // PERBAIKAN: Menggunakan relative path agar lolos blokir CORS Nginx
        await axios.post('/api/absen-guru', {
            guru_id: guru.guru_id,
            status: status,
            keterangan: keterangan
        }, { headers: { Authorization: `Bearer ${token}` } });

        Swal.fire({
            icon: 'success',
            title: 'Berhasil',
            text: `${guru.nama_guru} tercatat: ${status.toUpperCase()}`,
            timer: 1500,
            showConfirmButton: false
        });
    } catch (err) {
        Swal.fire('Gagal', 'Terjadi kesalahan saat menyimpan.', 'error');
    }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      {/* HEADER */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
            <h2 style={{ color: '#1e293b', margin: 0 }}>📝 Absensi Guru Piket</h2>
            <p style={{ margin: '5px 0 0', color: '#64748b' }}>Absen guru berdasarkan jadwal mengajar hari ini.</p>
        </div>
        <div style={{ background: 'white', padding: '10px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
            <span style={{ fontWeight: 'bold', color: '#334155', marginRight: '10px' }}>Hari:</span>
            <select 
                value={selectedHari} 
                onChange={(e) => setSelectedHari(e.target.value)} 
                style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }}
            >
                {['Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'].map(h => <option key={h} value={h}>{h}</option>)}
            </select>
        </div>
      </div>

      {/* LIST GURU PER JADWAL */}
      {loading ? <p style={{textAlign:'center'}}>Memuat jadwal guru...</p> : (
        <div style={{ display: 'grid', gap: '15px' }}>
            {jadwalGuru.length === 0 ? (
                <p style={{ textAlign: 'center', color: '#94a3b8', padding: '30px', fontStyle: 'italic' }}>Tidak ada jadwal mengajar pada hari ini.</p>
            ) : (
                jadwalGuru.map((g, idx) => (
                    <div key={idx} style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '15px' }}>
                        
                        {/* Info Guru & Jadwal */}
                        <div style={{ flex: 1, minWidth: '250px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <div style={{ width: '50px', height: '50px', background: '#e0e7ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', color:'#4361ee' }}>👨‍🏫</div>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '16px', color: '#1e293b' }}>{g.nama_guru}</h3>
                                    <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
                                        <span style={{ background: '#f1f5f9', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold', marginRight: '8px' }}>{g.jam_mulai.slice(0,5)} - {g.jam_selesai.slice(0,5)}</span>
                                        <span style={{ background: '#dbeafe', color: '#1e40af', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold' }}>{g.nama_kelas}</span>
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#334155', marginTop: '4px', fontWeight: '500' }}>{g.mapel}</div>
                                </div>
                            </div>
                        </div>

                        {/* Tombol Aksi (Absen Satu-satu) */}
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <button onClick={() => handleAbsen(g, 'hadir')} style={{ padding: '8px 15px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Hadir</button>
                            <button onClick={() => handleAbsen(g, 'telat')} style={{ padding: '8px 15px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Telat</button>
                            <button onClick={() => handleAbsen(g, 'izin')} style={{ padding: '8px 15px', background: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Izin</button>
                            <button onClick={() => handleAbsen(g, 'sakit')} style={{ padding: '8px 15px', background: '#8b5cf6', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Sakit</button>
                            <button onClick={() => handleAbsen(g, 'alfa')} style={{ padding: '8px 15px', background: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Alfa</button>
                        </div>

                    </div>
                ))
            )}
        </div>
      )}
    </div>
  );
};

export default AbsenGuru;